import React, { FunctionComponent } from 'react';
import { Prefecture } from '../../../types/personShow';

type Props = {
  suggestPrefectures: Prefecture[];
  prefectures: Prefecture[];
  selectedLocations: string[];
  onClick: (name: string) => void;
 };

export const Presentation: FunctionComponent<Props> = ({
  suggestPrefectures,
  prefectures,
  selectedLocations,
  onClick,
}) => {
  const isSelected = (target: string) => selectedLocations.includes(target);

  return (
    <div className="person__show__modal__inner">
      <p className="person__show__modal__inner--title">
        希望勤務地を選択して保存してください
        <span className="subtitle">※複数選択できます</span>
      </p>
      <div className="person__show__modal__inner__location__wrapper">
        <ul className="person__show__modal__inner__location">
          {suggestPrefectures.map((suggestPrefecture) => (
            <li
              key={`suggestion_${suggestPrefecture.name}`}
              className={isSelected(suggestPrefecture.name) ? 'selected' : ''}
              onClick={() => onClick(suggestPrefecture.name)}
              data-id={suggestPrefecture.id}
            >
              {suggestPrefecture.name}
            </li>
          ))}
        </ul>
      </div>
      <ul className="person__show__modal__inner__locationList long">
        {prefectures.map((prefecture) => (
          <li
            id={`person_show_modal_preferred_location_${prefecture.id}`}
            key={`location_${prefecture.name}`}
            className={isSelected(prefecture.name) ? 'selected' : ''}
            onClick={() => onClick(prefecture.name)}
            data-id={prefecture.id}
          >
            {prefecture.name}
            {isSelected(prefecture.name) && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="10"
                viewBox="0 0 14 10"
                fill="none"
              >
                <path
                  d="M4.88542 9.89714L0.21875 5.23047L1.11458 4.33464L4.88542 8.10547L12.8854 0.105469L13.7812 1.0013L4.88542 9.89714Z"
                  fill="#19190F"
                />
              </svg>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
